import type { TenderCaseListItemApi } from "@/api/tender-api"

/**
 * Returns at most `limit` cases, preserving API order (recent first).
 * If `activeCaseId` is set and not in the first `limit` rows, it is prepended
 * and the list is trimmed so the active case stays visible.
 */
export function limitTenderCasesForSidebar(
  cases: TenderCaseListItemApi[],
  limit: number,
  activeCaseId: string | undefined
): TenderCaseListItemApi[] {
  if (cases.length <= limit) return cases
  const base = cases.slice(0, limit)
  if (!activeCaseId) return base
  if (base.some((c) => c.id === activeCaseId)) return base
  const active = cases.find((c) => c.id === activeCaseId)
  if (!active) return base
  return [active, ...base.filter((c) => c.id !== activeCaseId)].slice(0, limit)
}
